import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import React from 'react';
import JournalDivider from '../Onboarding/JournalDivider';
import PasswordResetForm from './PasswordResetForm';
import { figtree } from '../Landing/fonts';
import { Accent, DisplayHeading, MUTED } from '../Landing/ui';

const PasswordResetDialog = props => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const { open, handleClose } = props;
  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        PaperProps={{
          className: `tw-bg-[#FFFDF6] dark:tw-bg-[#15231E] ${
            fullScreen ? '' : 'tw-rounded-3xl'
          }`,
        }}
        aria-labelledby="form-dialog-title"
      >
        <div
          className={`${figtree.className} signup-flow tw-relative ${
            fullScreen ? 'tw-flex-1 tw-overflow-y-auto tw-pb-48' : ''
          }`}
        >
          <button
            type="button"
            onClick={handleClose}
            aria-label="Close"
            className="tw-absolute tw-right-3 tw-top-3 tw-z-10 tw-flex tw-h-10 tw-w-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-[#5F6F69] dark:tw-text-[#93A69E] hover:tw-bg-[#1D2D28]/5 dark:hover:tw-bg-white/10"
          >
            <svg
              className="tw-h-5 tw-w-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>

          <div className="tw-px-6 tw-pb-6 tw-pt-10 sm:tw-px-8">
            <div className="tw-mb-6 tw-text-center">
              <p className="tw-mb-3 tw-mt-0 tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.28em] tw-text-primary-700 dark:tw-text-primary-300">
                Lost document
              </p>
              <DisplayHeading
                as="h2"
                className="tw-text-2xl tw-leading-tight"
                id="form-dialog-title"
              >
                Reset your <Accent>password</Accent>.
              </DisplayHeading>
              <p className={`${MUTED} tw-mb-0 tw-mt-3 tw-text-sm`}>
                Forgot your password? We will send you an email to reset your
                password.
              </p>
            </div>
            <PasswordResetForm />
            <JournalDivider label="Remembered it?" className="tw-my-5" />
            <div className="tw-pb-2 tw-text-center">
              <button
                type="button"
                onClick={props.switch}
                className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0 tw-text-[15px] tw-font-semibold tw-text-primary-700 dark:tw-text-primary-300 hover:tw-underline"
              >
                Back to login
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

PasswordResetDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default PasswordResetDialog;
